export default {
  subscriptions: (state, getters, { entities }) =>
    state.ids.map((id) => entities.subscriptions.byId[id]),
};
